module.exports = __webpack_public_path__ + "static/img/banner_solutions_intelligent.86af816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_intelligent.png
// module id = UToT
// module chunks = 10